import { render, staticRenderFns } from "./LogisticsHome.vue?vue&type=template&id=47ead20e&scoped=true&"
import script from "./LogisticsHome.vue?vue&type=script&lang=js&"
export * from "./LogisticsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ead20e",
  null
  
)

export default component.exports